import { BilledService } from 'app/pages/billing-general/billed/billed.service';
import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BillingEditService } from '../../../../../../core/services/billing-edit.service';
import {
  IBillingScheduleDetail,
  IDataEditBillingSchedule,
  IResponCharges,
  IScheduleAndEvent,
  ITripBillingInfo
} from '../../../../../../core/interfaces/billing.interface';
import { T2CardComponent } from '../../../../../../trip2-theme/components/t2-card/t2-card.component';
import { Subscription } from 'rxjs/Subscription';
import { assignNewArray, messagePermits } from '../../../../../A2-utils/export-functions/functions-services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RiderService } from '../../../../../riders/rider.service';
import { IRiderPayorBillingDefault } from '../../../../../../core/interfaces/rider-payor.interface';
import { T2LoadingService } from '../../../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { ParentModule } from '../../../../../A2-utils/ParentClass/parent-module';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from '../../../../../../core/helpers/sweet-alert-helper.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { constant } from '../../../../../../app.constants';
import { IDenialCategory } from 'app/core/interfaces/deposit.interface';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-info-trip-billing',
  templateUrl: './info-trip-billing.component.html',
  styleUrls: ['./info-trip-billing.component.scss']
})
export class InfoTripBillingComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  @Input() tripIdInput: number;
  @Input() riderIdInput: number;
  @Input() brokerId: number;
  @Input() billingInfo: ITripBillingInfo;
  @Input() reasonfortransport = [];
  @Output() updateChanges: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() payorid: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('modalEditScheduled') modalEditScheduled: T2CardComponent;
  @ViewChild('modalEditStatus') modalEditStatus: T2CardComponent;
  public gridDetails: GridOptions;
  public infoTripBilling: ITripBillingInfo = {} as ITripBillingInfo;
  public schedules: IScheduleAndEvent[] = [];
  public events: IBillingScheduleDetail[] = [];
  public payors: IRiderPayorBillingDefault[] = [];
  public form: FormGroup;
  public isBilled = false;
  public editPayor = true;
  private subscrip: Subscription[] = [];
  private subscripbillingscheduleid: Subscription;
  public billingStatus = constant.BILLING_STATUS_LIST;
  public denialCategories: IDenialCategory[]  = [];
  public selectedDenial: number;
  constructor(
    private service: BillingEditService,
    private BilledService: BilledService,
    private _riderService: RiderService,
    private _fb: FormBuilder,
    private _loadingInfo: T2LoadingService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    private dataProcessingService: DataProcessingService
  ) {
    super('app-add-charges-credits', Inject);
    this.gridDetails = < GridOptions > {};
    this.gridColumnDefs();
    this.createForm();
  }

  ngOnInit() {
    this.getInfoTripBilling();
    this.getScheduleAndEvent();
    this.getPayorsByRider();
    this.loadDenialCategories();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['billingInfo'] && changes['billingInfo'].currentValue) {
      this.infoTripBilling = this.billingInfo;
      this.validStatus(this.billingInfo.billingstatus);
      this.loadGridData(this.infoTripBilling['tripevents']);
      this.selectedDenial =
        this.infoTripBilling && this.infoTripBilling.denialcategoryid
          ? this.infoTripBilling.denialcategoryid
          : null;
    }
    if (changes['reasonfortransport'] && this.reasonfortransport) {
      if (!this.reasonsValid) {
        this.form.patchValue({ tripreasontransportid: undefined });
      }
    }
  }


  private loadDenialCategories(): void {
    if (!this.denialCategories || !this.denialCategories.length) {
      this.subscrip.push(
        this.BilledService.denialCategories$.subscribe({
          next: (data) => {
            this.denialCategories = data || [];
          }
        })
      );
    }
  }

  saveDenialCategory(): void {
    const tripId =
      this.infoTripBilling && this.infoTripBilling.tripid
        ? this.infoTripBilling.tripid
        : this.tripIdInput;
    const found =
      this.denialCategories && this.denialCategories.length
        ? this.denialCategories.find(
            (d) => d.denialcategoryid === this.selectedDenial
          )
        : null;
    const denialCategoryId = found ? found.denialcategoryid : null;
    if (!tripId) {
      return;
    }
    if (!denialCategoryId) {
      this.sweetAlertHelper.captureException('Select a valid Denial Category');
      return;
    }

    const data = {
      tripId,
      denialCategoryId,
    };

    this._loadingInfo.show();
    this.BilledService.categorizeDenialTrip(data)
      .pipe(finalize(() => this._loadingInfo.hiden()))
      .subscribe({
        next: () => {
          this.infoTripBilling.denialcategory = found.description;
          this.updateChanges.emit(true);
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      });
  }

  private createForm(): void {
    this.form = this._fb.group({
      payorid: '',
      tripid: '',
      billingscheduleid: '',
      tripreasontransportid : '',
      billingscheduledetailid: '',
    });
    this.subscripbillingscheduleid = this.form.get('billingscheduleid').valueChanges.subscribe(
      (id: number) => {
        if (id) {
          this.events = this.generateEvents(id);
        }
      }
    );
  }

  private listenForm(): void {
    this.subscrip.push(this.form.get('payorid').valueChanges.subscribe(
      (id: number) => {
        if (id) {
          const payor: IRiderPayorBillingDefault = this.payors.find(f => f.payorid === id);
          this.setControl('billingscheduleid', payor.billingscheduleiddefault);
        }
      }
    ));
    this.subscrip.push(this.form.get('billingscheduleid').valueChanges.subscribe(
      (value) => {
        this.assignEvents(value);
      }
    ));
  }

  unListenForm(): void {
    if (this.subscrip && this.subscrip.length) {
      this.subscrip.forEach(sub => sub.unsubscribe());
    }
  }
  /**
   * @description
   */
  private assignEvents(id: number): void {
    if (id) {
      const schedule: IScheduleAndEvent = this.schedules.find(f => f.billingscheduleid === id);
      if (schedule) {
        const event: IBillingScheduleDetail = schedule.billingscheduledetails[0];
        this.setControl('billingscheduledetailid', event.billingscheduledetailid);
      }
    } else {
      this.setControl('billingscheduledetailid', '');
    }
  }
  /**
   * @description
   */
  generateEvents(id: number): IBillingScheduleDetail[] {
    let data: IBillingScheduleDetail[] = [];
    const schedule: IScheduleAndEvent = this.schedules.find(f => f.billingscheduleid === id);
    if (schedule) {
      data = schedule.billingscheduledetails;
    }
    return data;
  }
  /**
   * @description carga el form
   */
  private loadForm(data: ITripBillingInfo) {
    this.form.patchValue(data);
    this.listenForm();
  }

  public resetForm(event: boolean): void {
    if (!event) {
      this.form.patchValue({
        payorid: undefined,
        billingscheduleid: undefined,
        billingscheduledetailid: undefined,
        tripreasontransportid: undefined,
      });
      this.unListenForm();
    }
  }
  /**
   * @description
   */
  private getInfoTripBilling(): void {
    if (this.tripIdInput) {
      this.subscrip.push(this.service.getChagesByTrip(this.tripIdInput, false).subscribe(
        (respon: IResponCharges) => {
          this.infoTripBilling = respon.tripbilling;
        }
      ));
    }
  }
  /**
   * @description
   */
  private getScheduleAndEvent(): void {
    this.subscrip.push(this.service.getBillingScheduleDetails().subscribe(
      (success: IScheduleAndEvent[]) => {
        this.schedules = assignNewArray(success);
      }
    ));
  }
  /**
   * @description genera la data
   */
  private generateData(): IDataEditBillingSchedule {
    return this.form.getRawValue();
  }
  /**
   * @description trae los payors del rider
   */
  private getPayorsByRider(): void {
    this.subscrip.push(this._riderService.getPayorAndBillingByRider(this.riderIdInput, this.brokerId).subscribe(
      (data: IRiderPayorBillingDefault[]) => {
        this.payors = data;
      }
    ));
  }
  /**
   * @description para guardar la edicion del schedule
   */
  public onSave(): void {
    this._loadingInfo.show();
    this.subscrip.push(this.service.editBillingSchedule(this.generateData()).subscribe(
      () => {
        this._loadingInfo.hiden();
        this.updateChanges.emit(true);
        this.onCloseEdit();
        this.dataProcessingService.getReloadGrid(true);
      },
      error => {
        this._loadingInfo.hiden();
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error',
          text: error.message,
          type: 'error',
        });
      }
    ));
  }
  /**
   * @description para abrir el modal de edicion
   */
  public onOpenEdit(): void {
    if (this.isAllowedAction('Edit Payor and Schedule')) {
      this.payorid.emit(this.billingInfo.payorid);
      this.modalEditScheduled.open();
      this.loadForm(this.billingInfo);
    } else {
      messagePermits('Edit Payor and Schedule');
    }
  }
  public onOpenEditBillingStatus(): void {
    if (this.isAllowedAction('Change Billing Status')) {
      this.modalEditStatus.open();
    } else {
      messagePermits('Edit Billing Status');
    }
  }
  /**
   * @description para cerrar modal
   */
  public onCloseEdit(): void {
    this.modalEditScheduled.close();
  }
  onCloseEditStatus(): void {
    this.modalEditStatus.close();
  }
  /**
   * @description setea valor al control
   */
  private setControl(control: string, value): void {
    this.form.get(control).setValue(value);
  }
  public onEditPayorPermison(): void {
    if (this.isAllowedAction('Edit Payor in Billed')) {
      this.editPayor = !this.editPayor;
      this.disabledPayorid(!this.editPayor);
    } else {
      messagePermits('Edit Payor');
    }
  }
  /**
   * @description valida el status
   */
  private validStatus(status: string): void {
    if (this.billingStatus[status] === 3) {
      this.isBilled = true; this.editPayor = false;
      this.disabledPayorid(true);
    } else {
      this.isBilled = false; this.editPayor = true;
      this.disabledPayorid(false);
    }
  }
  /**
   * @description deshabilita payorid segun parametro
   * @param disable
   */
  private disabledPayorid(disable: boolean): void {
    disable ? this.form.get('payorid').disable() : this.form.get('payorid').enable();
    this.form.get('payorid').updateValueAndValidity();
  }
  /**
   * @description emite cunando la actualizacion es successful
   */
  public updateChangesSuccess(event: boolean) {
    if (event) {
      this.updateChanges.emit(true);
    }
  }
  ngOnDestroy(): void {
    this.subscrip.forEach(sub => sub.unsubscribe());
    this.subscripbillingscheduleid.unsubscribe();
  }

  /**
   * @name loadGridData
   * @description Méotodo usado para asignar las columnas a la grilla
   */
  gridColumnDefs() {
    this.gridDetails.columnDefs = [
      {
        headerName: 'User',
        field: 'userfullname',
        width: 150,
      },
      {
        headerName: 'Event',
        field: 'eventdescription',
        width: 100,
      }, {
        headerName: 'Date',
        field: 'eventdate',
        width: 200,
      }
    ];
  }

   /**
   * @name loadGridData
   * @description Méotodo usado para asignar los datos a la grilla
   * @param data
   */

  loadGridData(data) {
    if (this.gridDetails) {
      if (this.gridDetails.api) {
        this.gridDetails.api.setRowData(data);
      }
    }
  }

  onChangePayorId() {
    const payorId = this.form.get('payorid').value;
    this.payorid.emit(payorId);
  }


  get isDenialBillingStatus(): boolean {
    return this.infoTripBilling && this.infoTripBilling.billingstatusid === this.billingStatus.Denied;
  }

  get reasonsValid(): boolean {
    return this.reasonfortransport.length ? true : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/components/info-trip-billing/info-trip-billing.component.ts